import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-cta-container',
  templateUrl: './cta-container.component.html',
  styleUrls: ['./cta-container.component.scss']
})
export class CTAContainerComponent {

  @Input() primaryBtnLabel: string;
  @Input() secondaryBtnLabel: string;
  @Input() isPrimaryBtnDisabled: boolean;
  @Input() isPrimaryBtnHidden: boolean;
  @Input() isSecondaryBtnSmall: boolean;
  @Input() isSecondaryBtnHidden: boolean;
  @Input() displayBtnContainer = true;
  @Input() isCenterAlignedAfterScroll: boolean; // this flag is to determine that when user has reached the end of the page then the pair of CTA btns will be center aligned
  @Input() isPrimaryBtnBlue: boolean;
  @Input() columnLayoutInMobile = false;
  @Input() ctaText: string;
  @Input() adobeSubmitTriggerClass = 'adobe-cta-container-trigger';
  @Input() IsButtonReverse = false;
  @Output() actionSelected = new EventEmitter<string>();
  constructor() { this.adobeSubmitTriggerClass = 'adobe-cta-container-trigger' }

  emitBtnEvent(event: string): void {
    this.actionSelected.emit(event);
  }
}
